/*
 * File: GetCourseSelfScheduleCriteria.ts
 * Author: Austin Robinson
 * Date Created: 10/9/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type GetCourseSelfScheduleCriteriaParams = {
  courseId: string;
};

export type GetCourseSelfScheduleCriteriaResult = {
  tenant_id: string;
  course_id: string;
  updated_at: string;
  min_time_from_first_to_last: PostGreSQLInterval | null;
  max_time_from_first_to_last: PostGreSQLInterval | null;
  min_time_between_periods: PostGreSQLInterval | null;
  max_bookings_in_advance: number | null;
  max_bookings_in_interval: number | null;
  max_bookings_interval: PostGreSQLInterval | null;
  require_permit: boolean | null;
  first_period_max_balance: number | null;
  last_period_max_balance: number | null;
  other_max_balance: number | null;
  updated_by_user: {
    tenant_id: string;
    id: string;
    title: string | null;
    first_name: string | null;
    middle_name: string | null;
    last_name: string | null;
    nickname: string | null;
    email: string | null;
    date_of_birth: string | null;
    sex: string | null;
    active: boolean;
    created_at: string | null;
    updated_at: string | null;
    created_by: string | null;
    updated_by: string | null;
    des_id: string | null;
  };
};

async function getCourseSelfScheduleCriteria(
  params: GetCourseSelfScheduleCriteriaParams,
): Promise<GetCourseSelfScheduleCriteriaResult> {
  // make api call
  const result = await privateApi.get(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/selfScheduleCriteria`,
    {},
  );

  // return the data object
  return result.data as GetCourseSelfScheduleCriteriaResult;
}

const useGetCourseSelfScheduleCriteria = createQuery<
  GetCourseSelfScheduleCriteriaResult,
  GetCourseSelfScheduleCriteriaParams,
  Error
>({
  queryKey: ['course_self_schedule_criteria'],
  fetcher: (variables) => getCourseSelfScheduleCriteria(variables),
});

export { getCourseSelfScheduleCriteria, useGetCourseSelfScheduleCriteria };
